import { render, staticRenderFns } from "./newssoft.vue?vue&type=template&id=5127853b&scoped=true&"
import script from "./newssoft.vue?vue&type=script&lang=js&"
export * from "./newssoft.vue?vue&type=script&lang=js&"
import style0 from "./newssoft.vue?vue&type=style&index=0&id=5127853b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127853b",
  null
  
)

export default component.exports